<div class="flex w-4/5 items-center">
  <p class="text-xl capitalize">upload files</p>
</div>
<div class="flex w-1/5 justify-end">
  <button
    mat-raised-button
    matTooltip="Please select timesheet before uploading attachment"
    class="text-base capitalize disabled:!bg-slate-50 disabled:!opacity-70"
    [matTooltipDisabled]="!!isAttachButtonEnabled"
    [disabled]="!isAttachButtonEnabled"
    (click)="fileInput.click()"
  >
    attach
  </button>
  <input #fileInput type="file" hidden (change)="onChange(fileInput)" />
</div>
